export default "__VITE_ASSET__5e66b27d__"